import debug from 'debug'

export const routingDebug = debug('routing')
